import { useEffect, useState } from "react";
import getUrl from "../../utility/getUrl";
import { AuthenticationInfoType } from "../../utility/types";
import { ProjectTimeLineItem, ProjectSize } from "../PublishProject/types";
import { shortDateTime } from "../PublishProject/util";
import ProjectTimeLineType from "./ProjectTimeLineType";

const sizeUnknownString = "size unknown";

type ProjectTimeLineRowProps = {
  projectId: string;
  auth: AuthenticationInfoType;
  timeLineItem: ProjectTimeLineItem;
  displayUTC: boolean;
};
const ProjectTimeLineRow = ({ projectId, auth, displayUTC, timeLineItem }: ProjectTimeLineRowProps) => {
  const [projectSize, setProjectSize] = useState<string>(sizeUnknownString);

  useEffect(() => {
    setProjectSize(sizeUnknownString);
  }, [projectId]);

  const onClickButtonGetSize = async (organizationId: string, projectId: string) => {
    try {
      const url = getUrl("projectSize", organizationId.trim(), projectId.trim());
      const options = {
        headers: new Headers({
          Authorization: `Bearer ${auth.accessToken}`,
        }),
      };
      const response = await fetch(url, options);

      if (response.status !== 200) {
        throw new Error(`${response.status} loading project-size`);
      }

      let projectSize = (await response.json()) as ProjectSize;
      let displaySize = "";
      if (projectSize.sizeInMegaBytes) {
        displaySize = projectSize.sizeInMegaBytes + " MegaBytes";
      } else if (projectSize.sizeInKiloBytes) {
        displaySize = projectSize.sizeInKiloBytes + " KiloBytes";
      } else {
        displaySize = projectSize.sizeInBytes + " Bytes";
      }

      setProjectSize(displaySize);
    } catch (err) {
      console.error(err);
    }
  };

  const sDate = shortDateTime(timeLineItem.date, displayUTC);
  const disabled = !timeLineItem.active ? "disabled" : "";

  return (
    <>
      <div className={disabled}>Id {timeLineItem.id}</div>
      <div className={disabled}>Version {timeLineItem.version}</div>
      <ProjectTimeLineType type={timeLineItem.type}></ProjectTimeLineType>
      <div className={disabled}>{sDate}</div>
      <div>{projectSize}</div>
      <button onClick={() => onClickButtonGetSize(timeLineItem.organizationId, timeLineItem.id)}>get size</button>
    </>
  );
};

export default ProjectTimeLineRow;
